import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '../directive.js';
import { payrollSubStaffDetail, payrollSubStaffDetailSave, payrollStaffDetail, payrollStaffDetailSave } from '@/api/payroll';
import basicInfo from './basic-info';
import basicSalary from './basic-salary';
import taxInfo from './tax-info';
import deductInfo from './deduct-info.vue';
import fundProvident from './fund-providen.vue';
import fundWelfare from './fund-welfare.vue';
import socialProvident from './social-provident';
var validateTax = function validateTax(rule, value, callback) {
  var message = rule.message;
  if (!value) return callback(new Error(message));
  return callback();
};
var validatePass = function validatePass(rule, value, callback) {
  var max = rule.max,
    message = rule.message;
  if (value && value > max) return callback(new Error(message));
  return callback();
};
export var validateDeduction = function validateDeduction(rule, value, callback) {
  var arr = rule.arr,
    message = rule.message,
    max = rule.max,
    mix = rule.mix,
    mixMax = rule.mixMax,
    multiple = rule.multiple;
  if (mix && mix > mixMax) return callback(new Error(message));
  if (max && value && value > max) return callback(new Error(message));
  if (arr && !arr.includes(Number(value))) return callback(new Error(message));
  if (multiple && value && Number(value) % multiple !== 0) return callback(new Error(message));
  return callback();
};
export default {
  components: {
    basicInfo: basicInfo,
    basicSalary: basicSalary,
    taxInfo: taxInfo,
    deductInfo: deductInfo,
    fundProvident: fundProvident,
    fundWelfare: fundWelfare,
    socialProvident: socialProvident
  },
  props: {
    staffId: String,
    subProjectId: String,
    type: String,
    show: Boolean
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      activeName: 'info',
      staffInfo: {},
      showDetail: false,
      row: {},
      rules: {
        provident_fund_status: [{
          required: true,
          message: this.$t('221')
        }],
        welfare_fund_status: [{
          required: true,
          message: this.$t('221'),
          trigger: 'change'
        }],
        tax_deduction_status: [{
          required: true,
          message: this.$t('958'),
          trigger: 'change'
        }],
        social_security_status: [{
          required: true,
          message: this.$t('959'),
          trigger: 'change'
        }],
        bank_card_no: [{
          required: true,
          message: this.$t('960'),
          trigger: 'blur'
        }, {
          min: 10,
          max: 12,
          message: this.$t('961'),
          trigger: 'blur'
        }],
        // tax_id: [{ required: true, message: this.$t('962'), trigger: 'blur' }],
        tax_id: [{
          required: true,
          validator: validateTax,
          message: this.$t('962'),
          trigger: 'blur'
        }],
        salary_day: [{
          required: true,
          message: this.$t('963'),
          trigger: 'blur'
        }],
        // salary_basic: [{ required: true, message: this.$t('964'), trigger: 'blur' }],
        salary_update_start_date: [{
          required: true,
          message: this.$t('966'),
          trigger: 'change'
        }],
        salary_basic_later: [{
          required: true,
          message: this.$t('965'),
          trigger: 'blur'
        }],
        // 夫妻抵扣
        tax_deduction_7: [{
          trigger: 'blur',
          validator: validateDeduction,
          arr: [0, 60000, 120000],
          message: this.$t('payroll_salary_7')
        }],
        // 子女抵扣
        tax_deduction_8: [{
          trigger: 'blur',
          validator: validateDeduction,
          max: 210000,
          multiple: 30000,
          message: this.$t('23786_19bbfb86')
        }],
        // 父母抵扣
        tax_deduction_9: [{
          trigger: 'blur',
          validator: validateDeduction,
          arr: [0, 30000, 60000, 90000, 120000],
          message: this.$t('payroll_salary_9')
        }],
        // 人寿保险
        tax_deduction_10: [{
          trigger: 'blur',
          validator: validateDeduction,
          mix: 0,
          max: 100000,
          mixMax: 100000,
          message: this.$t('payroll_deduction_error_2')
        }],
        // 医疗保险
        tax_deduction_11: [{
          trigger: 'blur',
          validator: validateDeduction,
          mix: 0,
          max: 25000,
          mixMax: 100000,
          message: this.$t('payroll_deduction_error_3')
        }],
        // 父母医疗保险
        tax_deduction_12: [{
          trigger: 'blur',
          validator: validatePass,
          max: 15000,
          message: this.$t('payroll_deduction_error_5')
        }],
        // 超级储蓄基金投资
        tax_deduction_13: [{
          trigger: 'blur',
          validator: validateDeduction,
          mix: 0,
          max: 200000,
          mixMax: 500000,
          message: this.$t('payroll_deduction_error_6')
        }],
        // 共同基金
        tax_deduction_14: [{
          trigger: 'blur',
          validator: validateDeduction,
          mix: 0,
          max: 500000,
          mixMax: 500000,
          message: this.$t('payroll_deduction_error_7')
        }],
        // 残疾人或弱者抵扣
        tax_deduction_17: [{
          trigger: 'blur',
          validator: validateDeduction,
          max: 999999999.99,
          multiple: 60000,
          message: this.$t('23786_319bbfb8')
        }],
        // 养老保险
        tax_deduction_19: [{
          trigger: 'blur',
          validator: validateDeduction,
          mix: 0,
          max: 200000,
          mixMax: 500000,
          message: this.$t('23786_9bbfb861')
        }],
        tax_deduction_15: [{
          message: this.$t('payroll_deduction_error_8'),
          trigger: 'blur',
          max: 100000,
          validator: validatePass
        }],
        // 社保
        salary_last_ss: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 累计已交公积金
        salary_last_pf: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 累计已交福利基金
        salary_last_wf: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 本年累计固定收入
        salary_last_fix: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 本年累计固定收入税额
        salary_year_accumulate_fix_tax: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 本年累计非固定收入
        salary_year_accumulate_notfix: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        // 本年累计非固定收入税额
        salary_year_accumulate_notfix_tax: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }],
        tax_rule: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'change'
        }],
        tax_rate: [{
          required: true,
          message: this.$t('1593'),
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    visible: function visible(n) {
      if (n) {
        this.loadStaffDetail();
      }
    }
  },
  methods: {
    init: function init(row) {
      this.row = row;
      this.activeName = 'info';
      this.visible = true;
    },
    handleClick: function handleClick() {
      this.$refs[this.activeName].$el.scrollIntoView();
    },
    // 银行账号长度校验
    bankChange: function bankChange(min, max) {
      this.rules.bank_card_no[1].min = min;
      this.rules.bank_card_no[1].max = max;
    },
    loadStaffDetail: function loadStaffDetail() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, last, keys, deduction_status, provident, welfare, social, tax_rate, tax_rule;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.type === 'salay')) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return payrollStaffDetail({
                staff_id: _this.staffId
              });
            case 3:
              res = _context.sent;
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return payrollSubStaffDetail({
                staff_id: _this.staffId,
                sub_project_id: _this.subProjectId
              });
            case 8:
              res = _context.sent;
            case 9:
              if (res && res.code === 1) {
                if (_this.show) {
                  last = res.data.salary.last || res.data.salary;
                  last.forEach(function (item) {
                    item.list.forEach(function (citem) {
                      citem.val = citem.val && citem.val.toString().replace(/(^|\s)\d+/g, function (m) {
                        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
                      });
                    });
                  });
                  keys = Object.keys(res.data);
                  keys.forEach(function (item) {
                    var tax = !isNaN(Number(item.split('tax_deduction_')[1]));
                    var key = ['salary_last_fix', 'salary_year_accumulate_fix_tax', 'salary_year_accumulate_notfix', 'salary_year_accumulate_notfix_tax', 'salary_last_ss', 'salary_last_pf', 'salary_last_wf'];
                    var other = key.includes(item);
                    if (tax || other) {
                      res.data[item] = res.data[item] && res.data[item].toString().replace(/(^|\s)\d+/g, function (m) {
                        return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
                      });
                    }
                  });
                }
                _this.staffInfo = res.data;
                _this.staffInfo.staff_id = res.data.staff_info_id;
                _this.showDetail = true;
              }

              // tax_deduction_status 3个人所得税 4预扣税 2不扣税
              deduction_status = _this.staffInfo.tax_deduction_status;
              _this.staffInfo.tax_deduction_status = deduction_status === '1' ? '3' : deduction_status;
              provident = _this.staffInfo.provident_fund_status;
              welfare = _this.staffInfo.welfare_fund_status;
              social = _this.staffInfo.social_security_status;
              tax_rate = _this.staffInfo.tax_rate;
              tax_rule = _this.staffInfo.tax_rule;
              _this.$set(_this.staffInfo, 'social_security_status', social);
              _this.$set(_this.staffInfo, 'provident_fund_status', provident);
              _this.$set(_this.staffInfo, 'welfare_fund_status', welfare);
              _this.$set(_this.staffInfo, 'tax_rate', tax_rate || '');
              _this.$set(_this.staffInfo, 'tax_rule', !tax_rule || tax_rule === '0' ? '' : tax_rule);
              _this.rules.tax_id[0].required = ['3', '4'].includes(_this.staffInfo.tax_deduction_status) || _this.staffInfo.tax_deduction_status === '2' && _this.staffInfo.nationality !== 'TH';
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 扣税状态
    changeTax: function changeTax(item) {
      // item 3个人所得税 4预扣税 2不扣税
      var taxStatus = {
        4: '2',
        // 预扣税 无需缴纳
        2: '2',
        // 不扣税 无需缴纳
        3: '1' // 个人所得税 正常缴纳
      };

      this.staffInfo.social_security_status = taxStatus[item];
      this.staffInfo.provident_fund_status = taxStatus[item];
      this.staffInfo.welfare_fund_status = taxStatus[item];
      this.staffInfo.tax_rule = '';
      this.staffInfo.tax_rate = '';
      this.$refs.staffForm.clearValidate('tax_id');
      // 税为个人所得税、预扣税时，Tax ID为必填，其他为非必填
      this.rules.tax_id[0].required = item !== '2' || this.staffInfo.nationality !== 'TH';
      this.rules.tax_id[0].message = item === '2' && this.staffInfo.nationality !== 'TH' ? this.$t('968') : this.$t('962');
    },
    taxIdBlur: function taxIdBlur(val) {
      if (!val && this.staffInfo.tax_deduction_status === '2' && this.staffInfo.nationality === 'TH') {
        this.rules.tax_id[0].required = false;
        this.rules.tax_id[0].message = this.$t('962');
      }
    },
    blurDeduction10: function blurDeduction10(val) {
      var deduction11 = Number(this.staffInfo.tax_deduction_11); // 医疗保险
      this.$refs.staffForm.clearValidate('tax_deduction_10');
      this.rules.tax_deduction_10[0].mix = Number(val) + deduction11;
    },
    blurDeduction11: function blurDeduction11(val) {
      var deduction10 = Number(this.staffInfo.tax_deduction_10); // 人寿保险
      this.$refs.staffForm.clearValidate('tax_deduction_11');
      this.rules.tax_deduction_11[0].mix = Number(val) + deduction10;
      var mixMax = this.rules.tax_deduction_11[0].mixMax;
      if (Number(val) + deduction10 > mixMax) {
        this.rules.tax_deduction_11[0].message = this.$t('payroll_deduction_error_16');
      }
    },
    blurDeduction13: function blurDeduction13(val) {
      var deduction14 = Number(this.staffInfo.tax_deduction_14) || 0;
      var deduction19 = Number(this.staffInfo.tax_deduction_19) || 0;
      this.$refs.staffForm.clearValidate('tax_deduction_14');
      this.$refs.staffForm.clearValidate('tax_deduction_19');
      this.rules.tax_deduction_13[0].mix = Number(val) + deduction14 + deduction19;
      var mixMax = this.rules.tax_deduction_13[0].mixMax;
      if (Number(val) + deduction14 + deduction19 > mixMax) {
        this.rules.tax_deduction_13[0].message = this.$t('payroll_deduction_error_17');
      }
    },
    blurDeduction14: function blurDeduction14(val) {
      var deduction13 = Number(this.staffInfo.tax_deduction_13) || 0;
      var deduction19 = Number(this.staffInfo.tax_deduction_19) || 0;
      this.$refs.staffForm.clearValidate('tax_deduction_13');
      this.$refs.staffForm.clearValidate('tax_deduction_19');
      this.rules.tax_deduction_14[0].mix = Number(val) + deduction13 + deduction19;
      var mixMax = this.rules.tax_deduction_14[0].mixMax;
      if (Number(val) + deduction13 + deduction19 > mixMax) {
        this.rules.tax_deduction_14[0].message = this.$t('payroll_deduction_error_17');
      }
    },
    blurDeduction19: function blurDeduction19(val) {
      var deduction13 = Number(this.staffInfo.tax_deduction_13) || 0;
      var deduction14 = Number(this.staffInfo.tax_deduction_14) || 0;
      this.$refs.staffForm.clearValidate('tax_deduction_13');
      this.$refs.staffForm.clearValidate('tax_deduction_14');
      this.rules.tax_deduction_19[0].mix = deduction13 + Number(val) + deduction14;
      var mixMax = this.rules.tax_deduction_19[0].mixMax;
      if (deduction13 + Number(val) + deduction14 > mixMax) {
        this.rules.tax_deduction_19[0].message = this.$t('payroll_deduction_error_17');
      }
    },
    clearDeduction: function clearDeduction(field) {
      var _this2 = this;
      this.$set(this.staffInfo, field, '');
      this.$nextTick(function () {
        _this2.$refs.staffForm.clearValidate(field);
      });
    },
    handleBeforeClose: function handleBeforeClose(done) {
      if (this.loading) return;
      done();
    },
    handlerBack: function handlerBack() {
      if (this.loading) return;
      this.visible = false;
    },
    // 提交表单
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          // 是否有调薪
          if (_this3.staffInfo.is_salary_update === '1') {
            _this3.staffInfo.salary_basic_last = _this3.staffInfo.salary_basic;
            _this3.staffInfo.salary_pos_last = _this3.staffInfo.salary_pos;
            _this3.staffInfo.salary_exp_last = _this3.staffInfo.salary_exp;
            _this3.staffInfo.salary_computer_last = _this3.staffInfo.salary_computer;
            _this3.staffInfo.salary_rent_last = _this3.staffInfo.salary_rent;
            _this3.staffInfo.salary_other_fix_last = _this3.staffInfo.salary_other_fix;
          }
          _this3.doSubmit();
        } else {
          _this3.$message({
            message: _this3.$t('payroll_salary_5'),
            type: 'warning'
          });
          return false;
        }
      });
    },
    doSubmit: function doSubmit() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.loading = true;
              _this4.$nextTick(function () {
                var formEl = _this4.$refs.staffForm && _this4.$refs.staffForm.$el;
                if (formEl) formEl.scrollTop = 0;
              });
              _context2.prev = 2;
              if (!(_this4.type === 'salay')) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return payrollStaffDetailSave(_this4.staffInfo);
            case 6:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this4.$emit('getListData');
                _this4.visible = false;
                _this4.$message.success(_this4.$t('886'));
              }
              _context2.next = 14;
              break;
            case 10:
              _context2.next = 12;
              return payrollSubStaffDetailSave(_this4.staffInfo);
            case 12:
              _res = _context2.sent;
              if (_res && _res.code === 1) {
                _this4.$emit('getListData');
                _this4.visible = false;
                _this4.$message.success(_this4.$t('886'));
              }
            case 14:
              _context2.prev = 14;
              _this4.loading = false;
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2,, 14, 17]]);
      }))();
    },
    closeDialog: function closeDialog() {
      this.loading = false;
      this.$refs.staffForm.clearValidate();
    }
  }
};